import {checkEmail} from "../../forms/rules/Rules";

export default {
    name: [
        { required: true, message: Loc.g('Veuillez renseigner un nom de token valide'), trigger: 'blur' },
    ],
    staffId: [
        { required: true, message: Loc.g('Veuillez sélectionner un collaborateur'), trigger: 'blur' },
    ],
    scopes: [
        { required: true, message: Loc.g('Veuillez sélectionner au moins un scope'), trigger: 'blur' },
    ],
    redirectUri: [
        { required: true, message: Loc.g('Veuillez renseigner une url de redirection'), trigger: 'blur' },
        {
            validator: (rule, value, callback) => {
                const urls = value.trim().split('\n');
                const isValid = function (url) {
                    try {
                        url = new URL(url);
                    } catch (_) {
                        return false;
                    }
                    return url.protocol === "http:" || url.protocol === "https:";
                }

                for (const i in urls) {
                    if (!isValid(urls[i])) {
                        callback(new Error(window.i18n.__('Veuillez saisir une url valide')));
                    }
                }
                callback();
            }, trigger: 'blur'
        },
    ],
}